"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4zm-6 1H4v-4h5zM2 4h15v2H2z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
}, "1")], 'AddBusiness');